export default {
      id: "delete-white-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#delete-white",
      toString: function () {
        return this.url;
      }
    }